export default "__VITE_ASSET__CjZRi5Rb__"